import { SortingDirection } from '@common/react/components/Core/ItemsProvider/ItemsProvider';
import {
	ItemsProviderWithStoreProps,
} from '@common/react/components/Core/ItemsProviderWithStore/ItemsProviderWithStore';

import { AppointmentStatus } from '@app/objects/Appointment';

type pickProperties = 'defaultSort' | 'filterHandler' | 'sortHandler' | 'storeName' | 'loadRequest' | 'pagination'
	| 'filters';

export const defaultOptions: Pick<ItemsProviderWithStoreProps<AppointmentStatus>, pickProperties> = {
	defaultSort: ['sortOrder', SortingDirection.Ascending],
	filterHandler: () => true,
	sortHandler: (a, b) => (a.sortOrder - b.sortOrder),
	storeName: 'appointmentStatuses',
	loadRequest: 'appointmentStatus',
	pagination: { current: 1, pageSize: 100 },
	filters: {
		column: [{ caption: 'sortOrder', direction: SortingDirection.Ascending }],
		count: 100,
	},
};

export const storeName = 'statusItems';
export const typeName = 'statuses';
